import {
  JSONObject,
  JSONValue,
  LayoutInlineForm,
  LayoutObject,
} from '../../types/types';

// Flat form data for DefinitionForm: picks only the fields the form defines.
// Definition item names match the API object keys 1:1 (e.g. rcptid, nbpgid).
export const objectToFormData = (
  object: LayoutObject,
  form: LayoutInlineForm
): JSONObject => {
  const data: JSONObject = {};

  form.items.forEach((item) => {
    if (!item.name) {
      return;
    }

    const value = object[item.name];

    if (value === undefined) {
      return;
    }

    // Reference fields hold numeric ids in the data; the inputs work with strings.
    if (item.control?.type === 'reference' && typeof value === 'number') {
      data[item.name] = String(value);
      return;
    }

    data[item.name] = value as JSONValue;
  });

  return data;
};
